// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoP4 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_4";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP4 {
        this.VALUES ??= this.completar({
            "valor": {
                "es": "En caso de no aceptar la instalación de cookies, puedes acceder a nuestro sitio web mediante registro. En este caso, te informaremos de que solo se instalarán cookies que sean necesarias para garantizar la navegación por el sitio web, pero no se utilizarán cookies para analizar el comportamiento ni para mostrar publicidad o contenido personalizado, aunque sí podrás visualizar publicidad general no personalizada. Puedes rechazar la instalación de cookies y acceder a nuestro sitio web a través de este abono pulsando el botón \"Rechazar\"."
            },
            "defecto": "En caso de no aceptar la instalación de cookies, puedes acceder a nuestro sitio web mediante registro. En este caso, te informaremos de que solo se instalarán cookies que sean necesarias para garantizar la navegación por el sitio web, pero no se utilizarán cookies para analizar el comportamiento ni para mostrar publicidad o contenido personalizado, aunque sí podrás visualizar publicidad general no personalizada. Puedes rechazar la instalación de cookies y acceder a nuestro sitio web a través de este abono pulsando el botón \"Rechazar\"."
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
